import { Directive, ElementRef, Inject, Input } from "@angular/core";
import { EventBus } from "@skylab-angular-shared/core";
import { UIEvents } from "@skylab-angular-shared/ui";
import { EventBusBase } from "@skylab-shared/core";
import { BehaviorSubject } from "rxjs";

@Directive({ selector: '[sklFormDirty]' })
export class FormDirtyDirective {
	@Input('sklFormDirty') public state!: BehaviorSubject<boolean>;
    private controlEditedObserverId!: string;

    public constructor(
        @Inject(EventBus) private readonly eventBus: EventBusBase,
        private readonly elementRef: ElementRef
    ) {}

    public ngAfterViewInit(): void {
        this.controlEditedObserverId = this.eventBus.observe(UIEvents.ControlEdited, (element: HTMLElement) => {
            if (!this.state.value && this.elementRef.nativeElement.contains(element)) {
                this.state.next(true);
            }
		});
    }

	public ngOnDestroy(): void {
        this.eventBus.deleteObserver([this.controlEditedObserverId]);
	}
}
